"use client";

import { c as _c } from "react/compiler-runtime";
import MovieHero from "./MovieHero";
import MovieHeader from "./MovieHeader";
import MovieMeta from "./MovieMeta";
import MovieCredits from "./MovieCredits";
import MovieActions from "./MovieActions";
import GenreTags from "../_shared/GenreTags";
import LikedPercent from "../_shared/LikedPercent";
import type { SeriesDetail } from "@/types/series";
import type { Person, Tag } from "@/types/movies";
import type { BackgroundImages } from "../_shared/contentMeta";
interface Props {
  series: SeriesDetail;
  images: BackgroundImages;
  year: string;
  countries: Tag[];
  genres: Tag[];
  subtitles: string;
  persons: Person[];
  durationLabel: string;
  lastEpisodeUuid: string;
  hasActiveSubscription: boolean;
  hasActiveTicket: boolean;
  episodesLoading?: boolean;
  onBuyClick: () => void;
}
export default function SeriesHeroSection(t0) {
  const $ = _c(38);
  const {
    series,
    images,
    year,
    countries,
    genres,
    subtitles,
    persons,
    durationLabel,
    lastEpisodeUuid,
    hasActiveSubscription,
    hasActiveTicket,
    episodesLoading,
    onBuyClick
  } = t0;
  const t1 = series?.uuid;
  const t2 = series?.title_fa || "";
  const t3 = series?.title_en || "";
  const t4 = series?.in_watchlist || false;
  let t5;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3 || $[3] !== t4) {
    t5 = <MovieHeader uuid={t1} title={t2} title_en={t3} isbook={t4} />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const t6 = series?.age_restriction?.name || "";
  const t7 = String(series?.imdb_rate ?? "");
  let t8;
  if ($[5] !== countries || $[6] !== durationLabel || $[7] !== subtitles || $[8] !== t6 || $[9] !== t7 || $[10] !== year) {
    t8 = <div className="w-full hidden lg:block"><MovieMeta ageLimit={t6} seasons={durationLabel} year={year} rating={t7} countries={countries} subtitles={subtitles} /></div>;
    $[5] = countries;
    $[6] = durationLabel;
    $[7] = subtitles;
    $[8] = t6;
    $[9] = t7;
    $[10] = year;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== persons) {
    t9 = persons.length > 0 && <MovieCredits stars={persons} />;
    $[12] = persons;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== genres) {
    t10 = <GenreTags tags={genres} className="hidden lg:flex sm:mt-4 md:mt-6" />;
    $[14] = genres;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = series?.trailers?.[0]?.uuid || "";
  const t12 = series?.content_access || "";
  const t13 = series?.uuid || "";
  const t14 = series?.title_fa || series?.title_en || "";
  const t15 = series?.unique_code || "";
  const t16 = series?.coming_soon;
  let t17;
  if ($[16] !== episodesLoading || $[17] !== hasActiveSubscription || $[18] !== hasActiveTicket || $[19] !== images || $[20] !== lastEpisodeUuid || $[21] !== onBuyClick || $[22] !== t11 || $[23] !== t12 || $[24] !== t13 || $[25] !== t14 || $[26] !== t15 || $[27] !== t16) {
    t17 = <div className="w-full hidden lg:block"><MovieActions traileruuid={t11} status={t12} poster={images} uuid={t13} title={t14} uniqueCode={t15} lastEpisodeUuid={lastEpisodeUuid} onBuyClick={onBuyClick} hasActiveSubscription={hasActiveSubscription} hasActiveTicket={hasActiveTicket} comingSoon={t16} episodesLoading={episodesLoading} /></div>;
    $[16] = episodesLoading;
    $[17] = hasActiveSubscription;
    $[18] = hasActiveTicket;
    $[19] = images;
    $[20] = lastEpisodeUuid;
    $[21] = onBuyClick;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
    $[25] = t14;
    $[26] = t15;
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t10 || $[30] !== t17 || $[31] !== t5 || $[32] !== t8 || $[33] !== t9) {
    t18 = <div className="absolute bottom-4 md:top-1/8 lg:top-1/8 xl:top-1/5 mx-auto container max-w-3xl px-4 sm:px-6 lg:px-12 pt-20 sm:pt-24">{t5}{t8}{t9}{t10}{t17}</div>;
    $[29] = t10;
    $[30] = t17;
    $[31] = t5;
    $[32] = t8;
    $[33] = t9;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== images || $[36] !== t18) {
    t19 = <MovieHero background={images}>{t18}</MovieHero>;
    $[35] = images;
    $[36] = t18;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  return t19;
}